import apiService from "../../services/apiService";

export default {
  name: "Contact",
  data: () => {
    return {
      contact: {}
    };
  },
  async created() {
    this.contact = await apiService.getContact();
  }
}